import React from 'react';
import {
	Filter,
	TextInput,
	ReferenceInput,
	SelectInput,
} from 'admin-on-rest';

const currentYear = (new Date()).getFullYear()
const years = []
for ( var i = currentYear; i >= 2017; i-- ) {
	years.push({
		id: i,
		name: i
	})
}

export default (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
		<ReferenceInput label="Dealership" source="dealership" reference="dealerships">
			<SelectInput/>
		</ReferenceInput>
		<ReferenceInput label="Bank" source="bank" reference="banks">
			<SelectInput/>
		</ReferenceInput>
		<ReferenceInput label="Status" source="status_" reference="statuses">
			<SelectInput/>
		</ReferenceInput>
		<SelectInput label="OR/CR" source="or_cr" choices={[
			{ id: "submitted", name: "Submitted OR/CR" },
			{ id: "not_submitted", name: "Not Submitted OR/CR" },
		]} />
		<SelectInput label="Doc Def" source="doc_def" choices={[
			{ id: "has_doc_def", name: "Currently Has Doc Def" },
			{ id: "no_doc_def", name: "Currently Has No Doc Def" },
			{ id: "had_doc_def", name: "Had Doc Def" },
			{ id: "had_no_doc_def", name: "Had No Doc Def" },
		]} />
		<SelectInput label="Month" source="month" choices={[
			{ id: "1", name: "January" },
			{ id: "2", name: "February" },
			{ id: "3", name: "March" },
			{ id: "4", name: "April" },
			{ id: "5", name: "May" },
			{ id: "6", name: "June" },
			{ id: "7", name: "July" },
			{ id: "8", name: "August" },
			{ id: "9", name: "September" },
			{ id: "10", name: "October" },
			{ id: "11", name: "November" },
			{ id: "12", name: "December" },
		]} />
		<SelectInput label="Year" source="year" choices={[
			...years,
		]} />
		<SelectInput label="Period" source="time" choices={[
			{ id: "current_month", name: "This Month" },
			{ id: "last_month", name: "Last Month" },
			{ id: "all", name: "All Time" },
		]} />
    </Filter>
);



// WEBPACK FOOTER //
// ./src/CollectorAccount/AccountFilters.js